/* eslint-disable camelcase */
import _ from "lodash";

export default {
    env: state => state.env,

    lang: state => state.lang,
    platform: state => state.env.platform || "h5", // h5/wx/mp

   

    // 数码相关
    codeBase: state => state.codeBase,
    code: state => state.code, // 数码
    decodestatus: state => state.decodestatus,
    

    // 企业相关
    enterprise: state => state.enterprise,
    eNo: state => state.eNo, // 企业编号

    // 地理位置相关
    gis: state => state.gis,
    needGis: state => state.needGis,
    gpsType: state => state.gpsType +'',

    channelType: state => state.channelType,
    
};
